import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getCategoryDetails } from "../../../state/modules/category";

import CategoryHeaderTitle from "./CategoryHeaderTitle";

const CategoryHeaderTitleContainer = ({ hasVisualCategories }) => {
  const category = useSelector(getCategoryDetails);

  return (
    <CategoryHeaderTitle
      category={category}
      hasVisualCategories={hasVisualCategories}
    />
  );
};

CategoryHeaderTitleContainer.propTypes = {
  hasVisualCategories: PropTypes.bool
};

export default CategoryHeaderTitleContainer;
